import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import AdminColleges from './AdminColleges';
import AdminCompanies from './AdminCompanies';
import AdminCoordinators from './AdminCoordinators';
import AdminCountry from './AdminCountry';
import AdminDistrict from './AdminDistrict';
import AdminState from './AdminState';
import AdminStudent from './AdminStudent';
import AdminUniversity from './AdminUniversity';
import AdminPlacementDrives from './AdminPlacementDrives';
import AdminVacancies from './AdminVacancies';
import AdminApplications from './AdminApplications';
import AdminDashboardHome from './AdminDashboardHome';

function AdminDashboard() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const menuItems = [
    { path: '', label: 'Dashboard', icon: '📊' },
    { path: 'country', label: 'Country', icon: '🌍' },
    { path: 'state', label: 'State', icon: '🗺️' },
    { path: 'district', label: 'District', icon: '📍' },
    { path: 'university', label: 'University', icon: '🎓' },
    { path: 'colleges', label: 'Colleges', icon: '🏫' },
    { path: 'coordinators', label: 'Coordinators', icon: '👤' },
    { path: 'student', label: 'Student', icon: '🎓' },
    { path: 'companies', label: 'Companies', icon: '🏢' },
    { path: 'placement-drives', label: 'Placement Drives', icon: '📋' },
    { path: 'vacancies', label: 'Vacancies', icon: '💼' },
    { path: 'applications', label: 'Applications', icon: '📄' },
  ];

  const handleLogout = () => {
    navigate('/login');
  };

  return (
    <div className="admin-dashboard">
      <div className={`admin-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>Admin Panel</h2>
          <button 
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path || 'dashboard'}
              to={item.path}
              end={item.path === ''}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
            >
              <span className="nav-icon">{item.icon}</span>
              {isSidebarOpen && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            {isSidebarOpen && <span>Logout</span>}
            <span className="logout-icon">🚪</span>
          </button>
        </div>
      </div>
      <div className="admin-content">
        <Routes>
          <Route path="colleges" element={<AdminColleges />} />
          <Route path="companies" element={<AdminCompanies />} />
          <Route path="coordinators" element={<AdminCoordinators />} />
          <Route path="country" element={<AdminCountry />} />
          <Route path="district" element={<AdminDistrict />} />
          <Route path="state" element={<AdminState />} />
          <Route path="student" element={<AdminStudent />} />
          <Route path="university" element={<AdminUniversity />} />
          <Route path="placement-drives" element={<AdminPlacementDrives />} />
          <Route path="vacancies" element={<AdminVacancies />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="" element={<AdminDashboardHome />} />
        </Routes>
      </div>
    </div>
  );
}

export default AdminDashboard;

